<template>
  <div class="page">
    <MatchHeader />
    <MatchInfo />
    <VolleyBallHome />
    <Footer />
  </div>
</template>

<script>
import MatchHeader from '../../layout/MatchHeader.vue'
import VolleyBallHome from '@comm/components/match/volleyball/VolleyBallHome'
import MatchInfo from '@comm/components/MatchInfo.vue'
import Footer from '../../layout/Footer.vue'

export default {
  name: 'VolleyBall',
  components: {
    MatchHeader,
    Footer,
    MatchInfo,
    VolleyBallHome,
  },
  data() {
    return {}
  },
  created() {
    window.scrollTo(0, 0)
  },
  mounted() {},
  methods: {},
}
</script>
<style lang="scss" scoped>
.page {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/match/volleyball/home.vue